import { FETCH_MY_EVENTS, UPDATE_COUNTER } from '../../constants/actionTypes'
import { dispatch } from '../../store/'
import { db } from '../firebase';
import { doDeleteEvent}  from '../db'
import _ from 'lodash'

const myEventsRef = db.ref('/myEvents')
const eventsRef = db.ref('/events')

export const myEventsListener = (state, userId) => {
   
    if(state==='remove') return myEventsRef.child(userId).off()
    
    myEventsRef.child(userId).on('value', (myEventIdsSnap ) => {
        let myEventsArr = []
        // if myEvents dosn't exists exit and return null
        if(!myEventIdsSnap.exists()) {

            const myEventsArr = null
            return dispatch({type: FETCH_MY_EVENTS, myEventsArr})
        }
        
        // convert to array and count elements wtih length
        const eventIdsCounter = _.values(myEventIdsSnap.val()).length
        // map events IDs object to query event data
        _.map(myEventIdsSnap.val(), async (data, key)=> {

            const eventSnap = await eventsRef.child(key).once('value')
        
            if(!eventSnap.exists()){
                return myEventsRef.child(userId).child(key).remove()
            }
            const event = eventSnap.val()
            // push event data to myEventsArr
            myEventsArr.push(event)
            
            if(myEventsArr.length===eventIdsCounter){
                const payload = {
                    counterName: 'myEvents',
                    count: myEventsArr.length
                }
                dispatch({type: FETCH_MY_EVENTS, myEventsArr})
                dispatch({type: UPDATE_COUNTER, payload})
            }
            
       })
    })
}

export const deleteMyEvent = (userId, eventId) => {
    myEventsRef.child(userId).child(eventId).remove()
    doDeleteEvent(eventId)
    return 'done'
}




// WEBPACK FOOTER //
// ./src/firebase/database/handleMyEvents.js